export function chaveDdi(valor: unknown): string {
  if (valor == null || valor === '') {
    return '';
  }
  return String(valor).replace(/^\+/, '');
}

export function ddiIguais(a: unknown, b: unknown): boolean {
  if (a == null && b == null) {
    return true;
  }
  if (a == null || b == null || a === '' || b === '') {
    return a === b;
  }
  return chaveDdi(a) === chaveDdi(b);
}

export function normalizarDdiParaSelect(
  ddi: unknown,
  ddiList: Array<{ ddi?: string | number | null }> = []
): unknown {
  const chave = chaveDdi(ddi);
  if (!chave) {
    return ddi;
  }
  const encontrado = ddiList.find(item => chaveDdi(item?.ddi) === chave);
  return encontrado ? encontrado.ddi : ddi;
}
